// extracted by mini-css-extract-plugin
module.exports = {"container":"_2nbiQSrKlivF30mGV8Boln","divBtn":"_1oMOxmsEGFfluXYtuuUECG","delBtn":"_2Ry3B-XmpIt9d6HNXwCga3"};